<template>
    <div>
        <input v-model="formattedValue" 
               type="text" 
               style="text-align:right"
               v-on:keyup="formatOnFocus(formattedValue)"
               @focus="formatOnFocus(formattedValue)"
               :keydown="checkDwoDotsImproperCharacters()"
               @blur="formatOnOut(formattedValue)" 
               class="form-control"
               v-bind:class="{ disabledInput: disabled }">
    </div>
</template>

<script>

export default {
   name: 'FormattedInput',
   data () {
       return {
           formattedValue: null,
           unformattedValue: null
       }
   },
   props: ['value', 'disabled'],
   created(){
       this.formatOnCreated(this.value)
   },
   methods: {
     // format on created with two decimals
     formatOnCreated(value) {
        this.formattedValue = value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1`')
     },
     // format with indefinite number of decimals when cursor is set
     formatOnFocus(value){
        value = value.replace(/`/g, "")
        this.unformattedValue = Number(value)
        if(value==='0.00')
          value='';
        //console.log(this.unformattedValue)
        this.$emit('emit-value', this.unformattedValue)
        this.formattedValue = this.numberWithCommas(value)
     },
     numberWithCommas(x) {
        let parts = x.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "`")
        return parts.join(".");
    },
    // format on input field losing focus
    formatOnOut(value){
        value = value.replace(/`/g, "")
        value = Number(value)
        this.unformattedValue = value
        //console.log(this.unformattedValue)
        this.$emit('emit-value', this.unformattedValue)
        this.formattedValue = value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1`')
    },
    // prevents the user from entering second dot or improper character
    checkDwoDotsImproperCharacters(){
       this.containsTwoDots(); 
       this.containsImproperCharacters();
       
    },
    containsTwoDots() { 
       if(this.formattedValue.indexOf('.') != this.formattedValue.lastIndexOf('.')){
          
         let lastIndex = this.formattedValue.lastIndexOf('.');
         let length =  this.formattedValue.length;
         this.formattedValue = this.formattedValue.substring(0,lastIndex) + this.formattedValue.substring(lastIndex+1, length);
        
       } 
    },
    containsImproperCharacters(){
       let properCharacters = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', '`'];

       // in case the character is not in the list of proper characters, remove it
       for(let i=0; i<this.formattedValue.length; i++){
          if ( ! (properCharacters.indexOf(this.formattedValue[i]) > -1)){
          let indexToRemove = i;
          let length =  this.formattedValue.length;
          this.formattedValue = this.formattedValue.substring(0,indexToRemove) + this.formattedValue.substring(indexToRemove+1, length);
        }
       }

    }
   }
}

</script>

<style scoped>
  
    .disabledInput {
        pointer-events:none;
        background-color:#E9ECEF;
    }

</style>